import { IMAGES } from "assets/images";
import { FC } from "react";
import { useBoundStore } from "store";

interface props {
  open?: boolean;
}

export const SplashLoading: FC<props> = (props) => {
  return (
    <dialog open={props.open} className="modal ">
      <div className="modal-box max-w-md md:mx-auto p-3 shadow-none rounded-none h-screen max-h-none bg-[#EFEFEF]">
        <div className="flex flex-col items-center justify-center w-full h-full">
          <div className="relative mb-10">
            <svg
              width="260"
              height="453"
              viewBox="0 0 260 453"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M258.931 452.5V151.027C258.931 148.787 257.441 146.821 255.285 146.214L196.016 129.535C192.827 128.638 189.662 131.035 189.662 134.348V452.5"
                stroke="#CCC8BA"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 451.5L1.00002 151.027C1.00002 148.787 2.48954 146.821 4.64559 146.214L63.9144 129.535C67.1041 128.638 70.2688 131.035 70.2688 134.348L70.2688 451.5"
                stroke="#CCC8BA"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M88.7173 452L88.7174 132.747C88.7174 129.986 90.956 127.747 93.7174 127.747H166.91C169.671 127.747 171.91 129.986 171.91 132.747L171.909 452"
                stroke="#CCC8BA"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.4043 142.715V29.027C18.4043 27.2225 19.3766 25.5581 20.9483 24.6717L57.2436 4.20449C60.5767 2.32494 64.6995 4.73324 64.6995 8.55974V129.139"
                stroke="#CCC8BA"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M242.223 142.715V29.027C242.223 27.2225 241.25 25.5581 239.679 24.6717L203.383 4.20449C200.05 2.32494 195.927 4.73324 195.927 8.55975V129.487"
                stroke="#CCC8BA"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M186.779 452V9.87212C186.779 6.6778 183.395 4.59887 180.507 5.96327V5.96327C148.876 20.9051 111.725 21.0423 80.1665 5.94919V5.94919C77.3072 4.58172 74 6.66601 74 9.83544V452"
                stroke="#CCC8BA"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M104.729 36.897V36.897C120.739 44.3999 139.246 44.4436 155.292 37.0164L155.55 36.897"
                stroke="#CCC8BA"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M104.729 48.7318V48.7318C120.739 56.2348 139.246 56.2785 155.292 48.8513L155.55 48.7318"
                stroke="#CCC8BA"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M104.729 59.8705V59.8705C120.739 67.3735 139.246 67.4172 155.292 59.99L155.55 59.8705"
                stroke="#CCC8BA"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M104.729 71.7054V71.7054C120.739 79.2084 139.246 79.2521 155.292 71.8249L155.55 71.7054"
                stroke="#CCC8BA"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M104.729 83.5403V83.5403C120.739 91.0432 139.246 91.087 155.292 83.6597L155.55 83.5403"
                stroke="#CCC8BA"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M104.729 94.679V94.679C120.739 102.182 139.246 102.226 155.292 94.7985L155.55 94.679"
                stroke="#CCC8BA"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M86.6289 7.65785V7.01384C86.6289 5.45911 88.3251 4.49891 89.6582 5.29901L95.9866 9.09736C96.6473 9.4939 97.477 9.47563 98.1196 9.05039L102.297 6.28615C102.955 5.85021 103.809 5.84286 104.475 6.26738L108.891 9.0815C109.531 9.48891 110.345 9.49983 110.995 9.10969L119.898 3.766C120.209 3.57941 120.565 3.48083 120.928 3.48083H133.968"
                stroke="#CCC8BA"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M174.346 7.65785V7.01384C174.346 5.45911 172.65 4.49891 171.317 5.29901L164.989 9.09736C164.328 9.4939 163.498 9.47563 162.856 9.05039L158.678 6.28615C158.02 5.85021 157.166 5.84286 156.5 6.26738L152.084 9.0815C151.445 9.48891 150.63 9.49983 149.98 9.10969L141.077 3.766C140.766 3.57941 140.41 3.48083 140.047 3.48083H127.007"
                stroke="#CCC8BA"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div
              className="absolute inset-0 flex items-center justify-center"
              style={{
                background:
                  "linear-gradient(180deg, rgba(239, 239, 239, 0) 0%, rgba(239, 239, 239, 0.94) 84%, #EFEFEF 100%)",
              }}
            >
              <img
                className="w-[180px] h-[170px] mb-28"
                src={IMAGES.LOGOS.HAMILA_CENTER.main}
              />
            </div>
          </div>
          <div className="text-center text-lg text-gray-400 pb-7">
            به باشگاه مشتریان همیلا <br />
            سنتر خوش آمدید
          </div>
          {/* <span className="loading loading-spinner loading-lg bg-primary" /> */}
          <div className="w-12 overflow-hidden mb-14">
            <img
              className="scale-150"
              src={IMAGES.LOADING_SPINNER.HAMILA_CENTER}
              alt=""
            />
          </div>
        </div>
      </div>
    </dialog>
  );
};
